// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  list-style: none;
}

.activity-content {
  margin-bottom: 120px;
}

.my-masonry-grid { /* Not needed if autoprefixing */ /* Not needed if autoprefixing */
  display: flex;
  margin-left: -0; /* gutter size offset */
  gap: 5px;
  overflow: hidden;
  
}
.my-masonry-grid_column {
  padding-left: 0; /* gutter size */
  background-clip: padding-box;
}
.option-card-container {
  position: relative;
  padding: 10px 60px;
}

.option-card {
  position: relative;
  padding: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.option-card > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.option-card-title {
  position: absolute;
  bottom: 0px;
  left: 5px;
  width: calc(100% - 10px);
  background-color: rgba(0, 0, 0, 0.5);
  text-align: center;
  font-weight: bold;
  line-height: 30px;
  display: flex;
  align-items: center;
}

.option-card-name {
  margin: 0 6px;
  color: white;
  font-size: 16px;
}

.option-card-description {
  color: #e2e2e2;
  font-size: 14px;
}

.option-card-count {
  position: absolute;
  top: 8px;
  left: 8px;
  width: 50px;
  height: 50px;
  background-color: #ed5324c9;
  color: white;
  text-align: center;
  font-size: 12px;
  font-weight: bold;
  border-radius: 50% 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}

.option-card-select {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 30px;
  height: 30px;
}
.option-card-select svg {
  width: 100%;
  height: 100%;
  color: #ed5324;
}
.option-selected-text {
  width: 100%;
  text-align: center;
  font-weight: 500;
  padding: 4px;
  color: #ed5324;
}

.option-selected-text span {
  color: #6a6969;
}

.activity-header {
  width: 100%;
  position: relative;
}

.activity-banner > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.activity-title {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #ffffff99;
  display: flex;
  padding: 6px;
  align-items: center;
}
.activity-title-text {
  margin-right: 8px;
  font-weight: 500;
}

.activity-title-desc {
  color: #333;
  font-size: 12px;
}

.loading {
  z-index: 10;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  font-weight: 500;
  background-color: #6a696988;
}

.loading-inner {
  width: 150px;
  height: 120px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff99;
  border-radius: 8px;
}


.loading-text {
  color: #333;
  font-size: 16px;
}

.spinner {
  position: relative;
  width: 50px;
  height: 50px;
  margin: 0 auto;
  animation: loadingI 2s linear infinite;
  margin-bottom: 10px;
}

.bubble-1,
.bubble-2 {
  position: absolute;
  top: 0;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  background-color: #dd4620;
  animation: bounce 2s ease-in-out infinite;
}

.bubble-2 {
  top: auto;
  bottom: 0;
  animation-delay: -1s;
}


@keyframes loadingI {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes bounce {
  0%,
  100% {
    transform: scale(0);
  }
  50% {
    transform: scale(1);
  }
}

.no-option {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  font-weight: 500;
  color: #333;
}
.no-option-inner {
  width: 70%;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,mBACwB,gCAAgC,EAChC,gCAAgC;EACtD,aAAa;EACb,eAAe,EAAE,uBAAuB;EACxC,QAAQ;EACR,gBAAgB;;AAElB;AACA;EACE,eAAe,EAAE,gBAAgB;EACjC,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,wBAAwB;EACxB,oCAAoC;EACpC,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,2BAA2B;EAC3B,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;AACpB;;;AAGA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,SAAS;EACT,oBAAoB;AACtB;;;AAGA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;;IAEE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,UAAU;EACV,kBAAkB;AACpB","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.activity-content {\n  margin-bottom: 120px;\n}\n\n.my-masonry-grid {\n  display: -webkit-box; /* Not needed if autoprefixing */\n  display: -ms-flexbox; /* Not needed if autoprefixing */\n  display: flex;\n  margin-left: -0; /* gutter size offset */\n  gap: 5px;\n  overflow: hidden;\n  \n}\n.my-masonry-grid_column {\n  padding-left: 0; /* gutter size */\n  background-clip: padding-box;\n}\n.option-card-container {\n  position: relative;\n  padding: 10px 60px;\n}\n\n.option-card {\n  position: relative;\n  padding: 5px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.option-card > img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.option-card-title {\n  position: absolute;\n  bottom: 0px;\n  left: 5px;\n  width: calc(100% - 10px);\n  background-color: rgba(0, 0, 0, 0.5);\n  text-align: center;\n  font-weight: bold;\n  line-height: 30px;\n  display: flex;\n  align-items: center;\n}\n\n.option-card-name {\n  margin: 0 6px;\n  color: white;\n  font-size: 16px;\n}\n\n.option-card-description {\n  color: #e2e2e2;\n  font-size: 14px;\n}\n\n.option-card-count {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  width: 50px;\n  height: 50px;\n  background-color: #ed5324c9;\n  color: white;\n  text-align: center;\n  font-size: 12px;\n  font-weight: bold;\n  border-radius: 50% 50%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-content: center;\n}\n\n.option-card-select {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 30px;\n  height: 30px;\n}\n.option-card-select svg {\n  width: 100%;\n  height: 100%;\n  color: #ed5324;\n}\n.option-selected-text {\n  width: 100%;\n  text-align: center;\n  font-weight: 500;\n  padding: 4px;\n  color: #ed5324;\n}\n\n.option-selected-text span {\n  color: #6a6969;\n}\n\n.activity-header {\n  width: 100%;\n  position: relative;\n}\n\n.activity-banner > img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.activity-title {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background-color: #ffffff99;\n  display: flex;\n  padding: 6px;\n  align-items: center;\n}\n.activity-title-text {\n  margin-right: 8px;\n  font-weight: 500;\n}\n\n.activity-title-desc {\n  color: #333;\n  font-size: 12px;\n}\n\n.loading {\n  z-index: 10;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 24px;\n  font-weight: 500;\n  background-color: #6a696988;\n}\n\n.loading-inner {\n  width: 150px;\n  height: 120px;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  background-color: #ffffff99;\n  border-radius: 8px;\n}\n\n\n.loading-text {\n  color: #333;\n  font-size: 16px;\n}\n\n.spinner {\n  position: relative;\n  width: 50px;\n  height: 50px;\n  margin: 0 auto;\n  animation: loadingI 2s linear infinite;\n  margin-bottom: 10px;\n}\n\n.bubble-1,\n.bubble-2 {\n  position: absolute;\n  top: 0;\n  width: 20px;\n  height: 20px;\n  border-radius: 100%;\n  background-color: #dd4620;\n  animation: bounce 2s ease-in-out infinite;\n}\n\n.bubble-2 {\n  top: auto;\n  bottom: 0;\n  animation-delay: -1s;\n}\n\n\n@keyframes loadingI {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes bounce {\n  0%,\n  100% {\n    transform: scale(0);\n  }\n  50% {\n    transform: scale(1);\n  }\n}\n\n.no-option {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 24px;\n  font-weight: 500;\n  color: #333;\n}\n.no-option-inner {\n  width: 70%;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
